import React from 'react';
import TextField from 'material-ui/TextField';

export class MetaSeoFields extends React.Component {

    validateField = (value, name) => {
        (value.length < 1) ? this.props.hasError(name, true) : this.props.hasError(name, false);
    }

    render() {
        let {
            metaTitle,
            updateMetaTitleField,
            metaDescription,
            updateMetaDescriptionField,
            metaError
        } = this.props;

        metaTitle = metaTitle !== null ? metaTitle : '';
        metaDescription = metaDescription !== null ? metaDescription : '';

        return (
            <div>
                <TextField
                    multiline
                    margin="dense"
                    id="meta_title"
                    name="metaTitle"
                    label="Meta Title"
                    value={metaTitle || ''}
                    onChange={(event) => {
                        updateMetaTitleField(event.target.value);
                        this.validateField(event.target.value, event.target.name);
                    }}
                    error={metaError["metaTitle"] || metaTitle.length < 1}
                    helperText={metaError["metaTitle"] || metaTitle.length < 1 ? "Please fill in the content for Meta Title!" : "Type Meta Title here"}
                    fullWidth
                    required
                    //inputProps={{ maxLength: 70 }}
                />
                <span>
                    Characters used: {metaTitle ? metaTitle.length : '0'}/70
                </span>

                <TextField
                    multiline
                    margin="dense"
                    id="meta_description"
                    name="metaDescription"
                    label="Meta Description"
                    value={metaDescription || ''}
                    onChange={(event) => {
                        updateMetaDescriptionField(event.target.value);
                        this.validateField(event.target.value, event.target.name);
                    }}
                    error={metaError["metaDescription"] || metaDescription.length < 1}
                    helperText={metaError["metaDescription"] || metaDescription.length < 1 ? "Please fill in the content for Meta Description!" : "Type Meta Description here"}
                    fullWidth
                    required
                    //inputProps={{ maxLength: 156 }}
                />
                <span>
                    Characters used: {metaDescription ? metaDescription.length : '0'}/156
                </span>
            </div>
        )
    }
};

export default MetaSeoFields;


// WEBPACK FOOTER //
// ./src/containers/builder/form/meta_seo_fields.js